// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"551":"09529b3e","873":"7bfd1a72"}[chunkId] + ".chunk.css";
};